import React from 'react';
import './Hero.css';
import AmbientCanvas from './AmbientCanvas';
import { smoothScrollTo } from '../utils/smoothScroll';

const Hero = () => {
  const scrollTo = (id) => smoothScrollTo(id, 80, 1100);

  return (
    <section id="hero" className="hero">
      <AmbientCanvas />

      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-pulse"></span>
            <span>Software Engineering & Digital Growth Partner</span>
          </div>

          <h1 className="hero-title">
            We Engineer <span className="hero-gradient-text">High-Performance Software</span> & Scalable Digital Products
          </h1>

          <p className="hero-subtitle">
            From enterprise web platforms and mobile apps to cloud architecture and growth engineering — we deliver robust, high-availability software built for long-term success.
          </p>

          <div className="hero-actions">
            <button className="btn btn-primary hero-btn" onClick={() => scrollTo('contact')}>
              <span>Start Your Project</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>

            <button className="btn btn-secondary hero-btn" onClick={() => scrollTo('portfolio')}>
              <span>Explore Our Work</span>
            </button>

            <button className="btn btn-outline-eval hero-btn" onClick={() => scrollTo('evaluation')}>
              <span>Free 2-Min Audit</span>
            </button>
          </div>

          {/* Corporate Trust Metrics Ribbon */}
          <div className="hero-trust-ribbon">
            <div className="trust-stat">
              <div className="trust-number">50+</div>
              <div className="trust-label">Projects Delivered</div>
            </div>
            <div className="trust-divider"></div>

            <div className="trust-stat">
              <div className="trust-number">100%</div>
              <div className="trust-label">On-Time Launch</div>
            </div>
            <div className="trust-divider"></div>

            <div className="trust-stat">
              <div className="trust-number">5.0 ★</div>
              <div className="trust-label">Client Rating</div>
            </div>
            <div className="trust-divider"></div>

            <div className="trust-stat">
              <div className="trust-number">Direct</div>
              <div className="trust-label">Engineer Access</div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-bottom-glow"></div>
    </section>
  );
};

export default Hero;
